import React, { useState, useEffect } from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'
import subscriptionImage from 'assets/images/storage_fee.png'
import { Topography } from '../Topography/Topography'
import { PaymentsSection } from 'components/grid';
import styles from './SubscriptionModal.module.scss'
import clsx from 'clsx';
import { InputLabel } from '../InputLabel/InputLabel';
import { Input } from '../Input/Input';
import { AddPayment } from 'pages/recordRequest/addPayment/AddPayment';
import { useDispatch, useSelector } from 'react-redux';
import { subscribeStorage } from 'store/actions/subscription';
import { subscriptionSelector } from 'store/reducers/subscription';

import { PreloaderWrapper } from 'components/containers';
import Alert from 'components/ui/Alert/Alert'

interface PropTypes {
    isOpen: boolean
    toggle: () => void
    isReqCreatedMoreThanThirtyDays?: boolean
    toggleSubscriptionModalOnClose?: () => void
    isRecordRequest?: boolean
}

export const SubscriptionModal: React.FC<PropTypes> = ({ isOpen, toggle, isReqCreatedMoreThanThirtyDays, toggleSubscriptionModalOnClose, isRecordRequest }) => {
    const dispatch = useDispatch()
    const { isLoading, error, message, subscription } = useSelector(subscriptionSelector)
    const isSubscriptionCancelled = subscription?.is_subscription_deactive
    const [paymentOpen, setPaymentOpen] = useState<boolean>(false)
    const [selectedPayment, selectPayment] = useState<string | undefined>()
    const [initials, setInitials] = useState<string>('')
    const [isAddCardOpen, setAddCardOpen] = useState<boolean>(false)

    useEffect(() => {
        setPaymentOpen(false)
        selectPayment(undefined)
        setInitials('')
        setAddCardOpen(false)
    }, [isOpen])

    const handleSubscription = () => {
        if (selectedPayment && initials) dispatch(subscribeStorage({ card_id: selectedPayment, initials }, () => {
            setTimeout(toggle, 1000)
        }))
    }
    const toggleAddCard = () => setAddCardOpen(!isAddCardOpen)
    const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (event:any) => {
    const newText = event.target.value;
    // Define a regular expression that only matches letters and spaces
    const regex = /^[A-Za-z\s]+$/;

    if (regex.test(newText) || newText === '') {
      setInputValue(newText);
      setInitials(newText)
      setErrorMessage('');
    } else {
      setErrorMessage('Only letters and spaces are allowed.');
    }
}

    return (
        <Modal isOpen={isOpen} centered toggle={toggleSubscriptionModalOnClose ? toggleSubscriptionModalOnClose : toggle} size='lg'>
            <ModalHeader toggle={toggleSubscriptionModalOnClose ? toggleSubscriptionModalOnClose : toggle} className='text-center'>
                <Topography.H4>Store & Share</Topography.H4>
            </ModalHeader>
            <ModalBody>
                <div>
                    <img src={subscriptionImage} className='img-fluid w-100' />
                </div>
                <div className='mt-3 text-justify'>
                    {!isReqCreatedMoreThanThirtyDays ?
                                `ChartRequest provides easy online access to your medical records for 30 days. 
                                After the 30-day period, records are archived into our secure embedded data vault.For 
                                continued access to your medical records after the 30-day period, we offer a $4.99/month 
                                unlimited sharing subscription. Click "Download & unlimited Sharing button" below to get started.`

                            : `ChartRequest provides seamless online access to your medical records. 
                            After 30 days of records availability, we have archived them into our embedded data vault. 
                            If you would like unlimited access to your medical records, we offer a $4.99 per month 
                            unlimited sharing subscription.`
                            }    
                        </div>
                {(error || message) && <Alert type={error ? "error" : "success"} className='mt-3'>{error || message}</Alert>}
                {isLoading ? <PreloaderWrapper /> : paymentOpen && isSubscriptionCancelled && (<div className={clsx(styles.paymentContainer, 'p-3 mt-3')}>
                    {isAddCardOpen ? (
                        <AddPayment isModal={true} onClose={toggleAddCard} />
                    ) : (<>
                        <div className='row'>
                            <div className='col-12 col-md-4'>
                                <InputLabel text='Your Initials' />
                                <Input type='text'  value={inputValue}  onChange={handleInputChange} />
                            </div>
                            <div className='col-12 mt-2'>
                                By adding my initials here, I agree to the $20.00 monthly subscription to store and share my records. Please submit monthly auto-payments to the following card:
                            </div>
                        </div>
                        <PaymentsSection onSelect={selectPayment} onClickAddCard={toggleAddCard} selected={selectedPayment} isModal={true} hideTitle={true} />
                    </>)}
                </div>)}
            </ModalBody>
            <ModalFooter> 
                 <Button className='mr-auto' color='gray' onClick={toggle}> { isRecordRequest ? `No Thanks` : !isReqCreatedMoreThanThirtyDays ? `Download Only`: `No Thanks`} </Button>           
                {paymentOpen ? isLoading ? null : (<Button color='warning' onClick={handleSubscription} disabled={!selectedPayment || !initials?.trim()}>Confirm Unlimited Sharing Subscription</Button>) : (<Button color='warning' onClick={() => setPaymentOpen(true)}>Download & unlimited Sharing</Button>)}
            </ModalFooter>
        </Modal>
    )
}